import Model from '@/store/model';

import TestOption from './test_option';
import Video from './video';
import Image from './image';
import Audio from './audio';
import Expression from './expression_response';
import ExpressionResponse from './expression_response';
import TestGraphicalOption from './test_graphical_options';
import FillTheGapsAnswer from './fill_the_gaps_answer_list';
import FillTheGapTestOption from './fill_the_gaps_test_options';
import HearingComprehensionTestOption from '@/store/models/contents/hearing_comprehension_test_otpions';

class ExpressionTest extends Model {
  map(json) {
    super.map(json);

    if (!!json.fill_the_gaps_answer_list && Array.isArray(json.fill_the_gaps_answer_list)) {
      this.mapArray('fillTheGapAnswerList', json.fill_the_gaps_answer_list, FillTheGapsAnswer);
    }

    if (!!json.fill_the_gaps_test_options && Array.isArray(json.fill_the_gaps_test_options)) {
      this.mapArray('fillTheGapTestOptions', json.fill_the_gaps_test_options, FillTheGapTestOption);
    }

    if (!!json.listening_comprehension_test_options && Array.isArray(json.listening_comprehension_test_options)) {
      this.mapArray('hearingComprehensionTestOptions', json.listening_comprehension_test_options, HearingComprehensionTestOption);
    }

    if (json.expression !== undefined && json.expression !== null) {
      this.expression = new Expression();
      this.expression.map(json.expression);
    }
    if (json.test_options !== undefined && json.test_options !== null) {
      this.mapArray('testOptions', json.test_options, TestOption);
    }
    if (json.video !== undefined && json.video !== null) {
      this.video = new Video();
      this.video.map(json.video);
    }
    if (json.test_graphical_options !== undefined && json.test_graphical_options !== null) {
      this.mapArray('testGraphicalOptions', json.test_graphical_options, TestGraphicalOption);
    }
    if (json.image !== undefined && json.image !== null) {
      this.image = new Image();
      this.image.map(json.image);
    }
    if (json.expression_list !== undefined && json.expression_list !== null) {
      this.mapArray('expressionList', json.expression_list, ExpressionResponse);
    }
    if (json.audio != null) {
      this.audio = new Audio();
      this.audio.map(json.audio);
    }
  }
}

export default ExpressionTest;
